import { useEffect, useState } from "react";
import coreValuesList from "../coreValueList";
import gcasConstitution from "../assets/gcas-constitution.pdf";
import communityPhoto from "../assets/images/coreValue2.png";
import slide1 from "../assets/images/slide1.png";
import slide2 from "../assets/images/slide2.png";
import slide3 from "../assets/images/slide3.png";
import slide4 from "../assets/images/slide4.png";
import slide5 from "../assets/images/slide5.png";
import slide6 from "../assets/images/slide6.png";
import slide7 from "../assets/images/slide7.png";
import slide8 from "../assets/images/slide8.png";
import slide9 from "../assets/images/slide9.png";
import slide10 from "../assets/images/slide10.png";

const SLIDE_DURATION_MS = 4000;

const reelPhotos = [
	{
		src: communityPhoto,
		alt: "GCAS members performing traditional music together at a cultural celebration",
	},
	{
		src: slide4,
		alt: "Members dressed up together at the GCAS End-of-Year Party",
	},
	{ src: slide5, alt: "Members dancing and celebrating together" },
	{
		src: slide1,
		alt: "A young member holding a plate of food at a GCAS gathering",
	},
	{
		src: slide9,
		alt: "Members sharing a laugh together during the holiday season",
	},
	{
		src: slide7,
		alt: "A couple celebrating together at a GCAS holiday gathering",
	},
	{ src: slide3, alt: "Children posing together at a GCAS family gathering" },
	{
		src: slide2,
		alt: "A mother serving her daughters food at a GCAS buffet",
	},
	{ src: slide8, alt: "Members chatting and laughing around the table" },
	{
		src: slide6,
		alt: "Members greeting each other warmly at a GCAS gathering",
	},
	{ src: slide10, alt: "A member receiving a certificate at a GCAS event" },
];

const ArrowIcon = ({ direction = "right" }) => (
	<svg
		width="13"
		height="13"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		style={direction === "left" ? { transform: "rotate(180deg)" } : undefined}
	>
		<path d="M5 12h14"></path>
		<path d="m12 5 7 7-7 7"></path>
	</svg>
);

function HomeAboutReel({ photos }) {
	const [index, setIndex] = useState(0);
	const [isPaused, setIsPaused] = useState(false);

	useEffect(() => {
		if (isPaused) return undefined;
		const id = window.setTimeout(() => {
			setIndex((current) => (current + 1) % photos.length);
		}, SLIDE_DURATION_MS);
		return () => window.clearTimeout(id);
	}, [index, isPaused, photos.length]);

	const goTo = (nextIndex) => {
		setIndex((nextIndex + photos.length) % photos.length);
	};

	return (
		<div
			className={`homeAboutReel ${isPaused ? "isPaused" : ""}`}
			onMouseEnter={() => setIsPaused(true)}
			onMouseLeave={() => setIsPaused(false)}
			onFocus={() => setIsPaused(true)}
			onBlur={() => setIsPaused(false)}
		>
			{photos.map((photo, i) => (
				<img
					key={photo.src}
					src={photo.src}
					alt={photo.alt}
					className={`homeAboutReelPhoto ${i === index ? "isActive" : ""}`}
				/>
			))}

			<div className="homeAboutReelScrim" aria-hidden="true"></div>

			<div className="homeAboutReelProgress">
				{photos.map((photo, i) => (
					<span className="homeAboutReelSegment" key={photo.src}>
						<span
							className={`homeAboutReelSegmentFill ${
								i < index ? "isDone" : i === index ? "isActive" : ""
							}`}
							style={
								i === index
									? { animationDuration: `${SLIDE_DURATION_MS}ms` }
									: undefined
							}
						/>
					</span>
				))}
			</div>

			<button
				type="button"
				className="homeAboutReelArrow isPrev"
				aria-label="Show previous photo"
				onClick={() => goTo(index - 1)}
			>
				<ArrowIcon direction="left" />
			</button>
			<button
				type="button"
				className="homeAboutReelArrow isNext"
				aria-label="Show next photo"
				onClick={() => goTo(index + 1)}
			>
				<ArrowIcon direction="right" />
			</button>
		</div>
	);
}

const HomeAbout = () => {
	return (
		<section id="about" className="homeAboutSection">
			<div className="homeAboutIntroWrap">
				<div className="homeAboutIntro">
					<h2 className="homeAboutHeading">
						Dedicated to a strong sense of unity.
					</h2>
					<p className="homeAboutLede">
						GCAS has brought Ghanaians and Canadians together in
						Saskatchewan, welcoming everyone in the Ghanaian
						community and friends of Ghana.
					</p>
					<a
						href={gcasConstitution}
						className="btn btnGhostDark homeAboutCta"
						target="_blank"
						rel="noopener noreferrer"
					>
						Read our Constitution
					</a>
				</div>

				<div className="homeAboutReelWrap">
					<HomeAboutReel photos={reelPhotos} />
				</div>
			</div>

			<div className="homeAboutValuesBand">
				<div className="homeAboutValuesGrid">
					{coreValuesList.map((value) => (
						<div className="homeAboutValueCol" key={value.title}>
							<h3 className="homeAboutValueTitle">{value.title}</h3>
							<p className="homeAboutValueInfo">{value.info}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default HomeAbout;
